/* eslint-disable import/extensions */

import axios from 'axios';
import { el } from 'date-fns/locale';
import { getToken, saveToken, clearToken } from './login';
import { convertAction } from './convert';

const API_BASE_URL = 'https://accountingAPI.smartlogic.mn/api';

function isTokenExpired(token) {
  return !token || !token.expires_at || Date.now() >= token.expires_at;
}

async function loginAndSaveToken() {
  const { showLoginModal } = await import('./login.js');
  const result = await showLoginModal();
  if (result.state) saveToken(result.token);
  return result;
}

const toApiPeriod = (item) => {
  const year =
    item.year?.split?.('/')?.[0] ||
    item.year ||
    item.year_end?.split?.('-')?.[0] ||
    new Date().getFullYear();
  // const t_year = '2025';
  return {
    BeginDate: `${year}-01-01`,
    EndDate: `${year}-12-31`,
  };
  // return {
  //   BeginDate: `${2025}-01-01`,
  //   EndDate: `${2025}-12-31`,
  // };
};

const actionKeyDict = {
  guilgee_balance: {
    url: 'generalledger/GetTrialBalanceReport',
    method: 'POST',
    responseType: 'json',
  },

  avalga_uglug: {
    url: 'recpay/GetRecPayCustomerReport',
    method: 'POST', // axios GET + data → curl шиг ажиллана
    responseType: 'json', // Хэрвээ text бол text болгож болно
  },
  undsen_hurungu: {
    url: 'fixedasset/GetAssetBarcodeReport',
    method: 'POST', // axios GET + data → curl шиг ажиллана
    responseType: 'json', // Хэрвээ text бол text болгож болно
  },
  dahin_unelgee: {
    url: 'fixedasset/GetAssetBarcodeReport',
    method: 'POST', // axios GET + data → curl шиг ажиллана
    responseType: 'json', // Хэрвээ text бол text болгож болно
  },
  guilgee_jagsaalt: {
    url: 'generalledger/GetJournalCrossList',
    method: 'POST',
    responseType: 'json',
  },
  undsen_hurungi_jagsaalt: {
    url: 'fixedasset/GetAssetTypeDocumentList',
    method: 'POST', // axios GET + data → curl шиг ажиллана
    responseType: 'json', // Хэрвээ text бол text болгож болно
  },
  avlag_uglug_jagsaalt: {
    url: 'generalledger/GetJournalCrossList',
    method: 'POST', // axios GET + data → curl шиг ажиллана
    responseType: 'json', // Хэрвээ text бол text болгож болно
  },
};
//  const apiSource = {
//           1: 'guilgee_jagsaalt',
//           2: 'avlag_uglug_jagsaalt',
//           3: 'undsen_hurungi_jagsaalt',
//           6: 'undsen_hurungi_jagsaalt',
//         };

export default async function smartApi(actionKey, params = {}) {
  let token = getToken();

  if (!token || isTokenExpired(token)) {
    const loginResult = await loginAndSaveToken();
    if (!loginResult.state) return loginResult;
    token = getToken();
  }

  const action = actionKeyDict[actionKey];
  if (!action) {
    return { state: false, message: 'Unknown action' };
  }

  try {
    const url = `${API_BASE_URL}${action.url}`;
    let payload = null;

    // ----------------------------
    // 1) Balance report -> query params
    // ----------------------------
    if (actionKey === 'guilgee_balance') {
      const period = toApiPeriod(params);
      const search = new URLSearchParams(period).toString();
      payload = search;
    } else if (actionKey === 'avalga_uglug') {
      const period = toApiPeriod(params);
      const search = new URLSearchParams(period).toString();
      payload = search;
    } else if (actionKey === 'undsen_hurungu') {
      const period = toApiPeriod(params);
      const search = new URLSearchParams(period).toString();
      payload = search;
    } else if (actionKey === 'dahin_unelgee') {
      const period = toApiPeriod(params);
      const search = new URLSearchParams(period).toString();
      payload = search;
    } else if (
      actionKey === 'guilgee_jagsaalt' ||
      actionKey === 'avlag_uglug_jagsaalt'
    ) {
      const period = toApiPeriod(params);
      const payload_temp = {
        BeginDate: params.BeginDate || period.BeginDate,
        EndDate: params.EndDate || period.EndDate,
        AccountId: '',
        DebitAccountId: '',
        CreditAccountId: '',
      };
      const search = new URLSearchParams(payload_temp).toString();
      payload = search;
    } else if (actionKey === 'undsen_hurungi_jagsaalt') {
      const period = toApiPeriod(params);

      const payload_temp = {
        BeginDate: params.BeginDate || period.BeginDate,
        EndDate: params.EndDate || period.EndDate,
        DocumentType: '',
        AssetAccountId: '',
        AssetLocationId: '',
        EmployeeId: '',
        AssetId: '',
        AssetTypeId: '',
      };
      const search = new URLSearchParams(payload_temp).toString();
      payload = search;
    }
    if (actionKey === 'asset_barcode_report') {
      const period = toApiPeriod(params);

      payload = {
        BeginDate: params.BeginDate || period.BeginDate,
        EndDate: params.EndDate || period.EndDate,
        AssetAccountId: params.AssetAccountId || '',
        AssetId: params.AssetId || '',
        AssetTypeId: params.AssetTypeId || '',
      };
    }

    const response = await fetch(`${API_BASE_URL}/${action.url}`, {
      method: action.method,
      headers: {
        Authorization: `Bearer ${token.access_token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: payload, // This is EXACTLY like your curl --data-urlencode
    });

    // JSON биш бол convertAction алгасана ч болно
    console.log('response', response);
    const responseData = await response.json();
    console.log('responseData', responseData);

    const converted = convertAction(actionKey, responseData.Data, params);
    console.log('converted', converted);
    return { state: true, data: converted, message: 'Success' };
  } catch (error) {
    console.error('SmartLogic API Error:', error);

    // axios → error.response.status ашиглана
    if (error.response && error.response.status === 401) {
      clearToken();
      return { state: false, message: 'Unauthorized (401)' };
    }

    return {
      state: false,
      message: error?.response?.data?.message || error.message,
    };
  }
}
